import { createFileRoute, redirect } from '@tanstack/react-router';

/** Bare `/resetpassword` has no Guid — send players to forgot password. */
export const Route = createFileRoute('/resetpassword/')({
  beforeLoad: () => {
    throw redirect({ to: '/forgotpassword' });
  },
});
